import { render } from "./FivePoint.vue?vue&type=template&id=be07290c&scoped=true&ts=true"
import script from "./FivePoint.vue?vue&type=script&lang=ts"
export * from "./FivePoint.vue?vue&type=script&lang=ts"

import "./FivePoint.vue?vue&type=style&index=0&id=be07290c&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be07290c"]])

export default __exports__